<header class="header">
    <div class="container">
        <div class="select-language">
            <span>{{'selectLanguage' |translate}}</span>
        </div>
        <div class="language-button-wrapper" *ngFor="let lang of langs">
            <button [ngClass]="currentLanguage==lang.value ? 'current-language-button': 'language-button'" (click)="changeLanguage(lang.value)" nz-button nzSize="large" nzType="default">{{lang.value.toUpperCase()}}</button>
        </div>
    </div>
</header>
<router-outlet></router-outlet>
